module.exports = __webpack_public_path__ + "static/img/LU.ba963f79.svg";